export const variable = {
  id: null,
};
